import script from "./MainTable.vue?vue&type=script&setup=true&lang=js"
export * from "./MainTable.vue?vue&type=script&setup=true&lang=js"

import "./MainTable.vue?vue&type=style&index=0&id=8d2ea6d8&lang=scss"

const __exports__ = script;

export default __exports__